




































import Component, { mixins } from "vue-class-component";
import axios from "@/plugins/axios";
import ErrorMixin from "@/mixins/errorMixins";

@Component({
  components: {},
})
export default class ECash extends mixins(ErrorMixin) {
  public datePick: any = new Date().toISOString().substr(0, 10);
  public force = true;
  public client = true;
  public check = true;

  public DoExport() {
    this.$store.dispatch("login/setLoading", true);

    const url = `/withCredentials/ecash/suivantDate?datefiscale=${this.datePick}&force=${this.force}&to_client=${this.client}&check=${this.check}`;

    axios.get(url).then(
      (response: any) => {
        console.log(response);
        this.setSuccess(this.$t("exportOk").toString());
        this.$store.dispatch("login/setLoading", false);
      },
      (error) => {
        console.log(error);
        this.setErrorFromTxt(error.toString());
        this.$store.dispatch("login/setLoading", false);
      }
    );
  }
}
